import type { MapTypeId, Marker, MarkerFormatter, Rectangle } from '@libs/maps';

export interface MapConfig {
  markers?: Marker;
  markerFormatters?: Partial<MarkerFormatter>;
  startRectangle?: Rectangle;
  mapType?: MapTypeId;
}

export const enum MapType {
  Static = 'StaticMap',
  Dynamic = 'DynamicMap',
}
